<div>
    <p class="my-text" #tooltip="matTooltip" [matTooltip]="getTooltip()" [matTooltipPosition]="'above'" matTooltipHideDelay="500">{{ getTextBuffer() }}</p>
</div>
